<template>
  <div class="con-wrap" ref="conWrap" :class="{ openMap: isOpenMap }">
    <div id="map-box" class="box-border"></div>
    <el-header class="watch-header">
      <el-row class="header-title">运维车辆监控</el-row>
    </el-header>
    <el-row class="reload-time">
      数据刷新时间：<span>{{ monitorData.refreshTime }}</span>
    </el-row>
    <el-row class="survey-wrapper left-wrapper">
      <el-row class="survey-box">
        <el-header class="survey-header">车辆概况</el-header>
        <el-row class="survey-vehicle" style="cursor:pointer">
          <el-col
            :span="7"
            class="vehicle-num online"
            @click.native="goToVehicle(2)"
          >
            <el-row>在线</el-row>
            <el-row class="nums online-num">{{
              monitorData.vehicle.onLineCount
            }}</el-row>
          </el-col>

          <el-col
            :span="7"
            class="vehicle-num offline"
            @click.native="goToVehicle(1)"
          >
            <el-row>离线</el-row>
            <el-row class="nums offline-num">{{
              monitorData.vehicle.offLineCount
            }}</el-row>
          </el-col>
          <el-col
            :span="7"
            class="vehicle-num powering"
            @click.native="goToVehicle(3)"
          >
            <el-row>发电中</el-row>
            <el-row class="nums powering-num">{{
              monitorData.vehicle.powerCount
            }}</el-row>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="survey-box">
        <el-header class="survey-header" style="height:25px"
          >发电概况</el-header
        >
        <div id="chart" style="width:400px;height:200px;"></div>
      </el-row>
    </el-row>
    <el-row class="survey-wrapper right-wrapper">
      <el-row class="survey-box">
        <el-header class="survey-header">基站概况</el-header>
        <el-row class="survey-vehicle survey-baseStation">
          <el-col
            :span="10"
            class="vehicle-num baseStation-num"
            style="margin-right:35px"
          >
            <el-row>维护站址数</el-row>
            <el-row class="nums online-num">{{
              monitorData.station.totalCount
            }}</el-row>
          </el-col>
          <el-col :span="10" class="vehicle-num powerCut-num">
            <el-row>故障告警数</el-row>
            <el-row class="nums offline-num">{{
              monitorData.station.errorCount
            }}</el-row>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="survey-box">
        <el-header class="survey-header">工单概况</el-header>
        <el-row class="survey-vehicle survey-order" style="cursor:pointer">
          <el-col
            :span="10"
            class="vehicle-num ordering"
            style="margin-right:135px"
            @click.native="goToOrder(2)"
          >
            <el-row>在途工单</el-row>
            <el-row class="nums online-num">{{
              monitorData.order.onWayCount
            }}</el-row>
          </el-col>
          <el-col
            :span="10"
            class="vehicle-num no-order"
            @click.native="goToOrder(1)"
          >
            <el-row>待接工单</el-row>
            <el-row class="nums offline-num">{{
              monitorData.order.waitCount
            }}</el-row>
          </el-col>
        </el-row>
      </el-row>
    </el-row>
    <!-- 高德地图点击基站标注显示的盒子 -->
    <el-row
      class="infoWindow"
      ref="baseStationInfowindow"
      v-show="baseStationId"
    >
      <i class="delta"></i>
      <el-row class="infoWindow-detail">
        <el-row>{{ baseStationInfoWindowData.code }}</el-row>
        <el-row>{{ baseStationInfoWindowData.name }}</el-row>
        <el-row>
          <span>电压：</span>
          <span>{{
            baseStationInfoWindowData.voltage > 0
              ? baseStationInfoWindowData.voltage + "V"
              : "-"
          }}</span>
        </el-row>
        <el-row>
          <span>电流：</span>
          <span>{{
            baseStationInfoWindowData.electric > 0
              ? baseStationInfoWindowData.electric + "A"
              : "-"
          }}</span>
        </el-row>
        <el-row>
          <span>环境温度：</span>
          <span>{{
            baseStationInfoWindowData.temperature > 0
              ? baseStationInfoWindowData.temperature + "℃"
              : "-"
          }}</span>
        </el-row>
        <el-row>
          <span>环境湿度：</span>
          <span>{{
            baseStationInfoWindowData.humidity > 0
              ? baseStationInfoWindowData.humidity + "%RH"
              : "-"
          }}</span>
        </el-row>
      </el-row>
    </el-row>
    <!-- 高德地图点击车辆标注显示的盒子 -->
    <el-row class="infoWindow" ref="vehicleInfowindow" v-show="vehicleId">
      <i class="delta"></i>
      <el-row
        class="orderTime"
        v-if="
          vehicleInfoWindowData.orderState &&
            vehicleInfoWindowData.orderState != 1
        "
      >
        <el-col :span="8">工单历时</el-col>
        <el-col :span="16">{{ vehicleInfoWindowData.takeTime }}</el-col>
      </el-row>
      <el-row class="infoWindow-detail">
        <el-row class="vehicleStatus">
          <span class="powering" v-if="vehicleInfoWindowData.powerState == 1"
            >发电中</span
          >
          <span
            class="fueling"
            v-if="vehicleInfoWindowData.oilPumpingState == 1"
            >抽油中</span
          >
          <span class="no-receive" v-if="vehicleInfoWindowData.orderState == 1"
            >未接单</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 2"
            >在途中</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 3"
            >已接单</span
          >
        </el-row>
        <el-row class="carNumber">{{ vehicleInfoWindowData.plateNum }}</el-row>
        <el-row>{{ vehicleInfoWindowData.name }}</el-row>
        <el-row>{{ vehicleInfoWindowData.phone }}</el-row>
        <el-row>
          <span>剩余油量：</span>
          <span>{{ vehicleInfoWindowData.adFuel }}L</span>
        </el-row>
        <el-row
          v-if="
            vehicleInfoWindowData.orderState == 2 &&
              vehicleInfoWindowData.powerState != 1
          "
        >
          <el-row>
            <span>预计行程：</span>
            <span>{{ drivingRoutel }}</span>
          </el-row>
          <el-row>
            <span>预计用时：</span>
            <span>{{ drivingTime }}</span>
          </el-row>
        </el-row>
        <el-row v-if="vehicleInfoWindowData.powerState == 1">
          <el-row>
            <span>发电功率：</span>
            <span>{{ vehicleInfoWindowData.forwardPower }}W</span>
          </el-row>
          <el-row>
            <span>发电时长：</span>
            <span>{{ vehicleInfoWindowData.duration }}</span>
          </el-row>
          <el-row>
            <span>发电量：</span>
            <span>{{ vehicleInfoWindowData.capacity }}KW·H</span>
          </el-row>
        </el-row>
      </el-row>
      <span
        class="checkDetail"
        @click="getVehicleDetail(vehicleInfoWindowData.vin)"
      >
        查看详情
      </span>
    </el-row>
    <!-- 高德地图点击农行标注显示的盒子 -->
    <el-row class="infoWindow" ref="bankInfowindow" v-show="bankId">
      <i class="delta"></i>
      <el-row class="infoWindow-detail">
        <el-row>{{ bankInfoWindowData.stationId }}</el-row>
        <el-row>{{ bankInfoWindowData.name }}</el-row>
        <el-row>
          <span>负载：</span>
          <span>{{ bankInfoWindowData.dcLoadCurrent }}</span>
        </el-row>
        <el-row>
          <span>联系人：</span>
          <span>{{ bankInfoWindowData.contacts }}</span>
        </el-row>
        <el-row>
          <span>联系电话：</span>
          <span>{{ bankInfoWindowData.phone }}</span>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import AMap from "AMap"
export default {
  name: "monitor",
  data() {
    return {
      monitorLnglat: [],
      drivingTime: "",
      drivingRoutel: "",
      isOpenMap: false,
      map: null,
      styleObjectArr: [],
      myChart: "",
      datax: [],
      datay: [],
      stationMarks: null,
      fourShopMarks: null,
      baseStationSwitch: true,
      vehicleInfoSwitch: true,
      baseStationInfoWindow: null, // 基站信息窗体
      baseStationInfoWindowData: {},
      vehicleInfoWindow: null, // 车辆信息窗体
      vehicleInfoWindowData: {},
      bankInfoWindow: null,
      bankInfoWindowData: {},
      baseStationId: false,
      vehicleId: false,
      bankId: false,
      powering: true,
      fueling: true,
      routing: false,
      noOrder: false,
      noReceive: false,
      driving: null,
      routeLine: null,
      passedPolyline: null,
      timer: null,
      stationTimer: false,
      carTimer: false,
      oilStateMarker: null,
      powerStateMarker: null,
      vin: null,
      deptId: null,
      stationId: null,
      lnglat: [],
      marker: {},
      bkMarker: "",
      varMarker: "",
      varSMarker: "",
      baseStationData: [],
      bankData: [],
      fourShopData: [],
      vehicleLocal: [],
      stationLocal: [],
      bankMarker: [],
      vehicleMarker: [],
      stationMarker: [],
      oilStateMarkers: [],
      powerStateMarkers: [],
      monitorData: {
        refreshTime: "",
        order: {
          onWayCount: "",
          waitCount: "",
        },
        station: {
          totalCount: "",
          errorCount: "",
        },
        vehicle: {
          onLineCount: "",
          offLineCount: "",
          powerCount: "",
        },
      },
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path)
      console.log(this.monitorLnglat)
      sessionStorage.setItem("monitorLnglat", this.monitorLnglat)
    } else {
      sessionStorage.removeItem("monitorLnglat")
    }
    next()
  },
  mounted() {
    this.initMap() //  初始化地图
    this.initCharts() // 初始化折线图
    this.getPowerCharts() // 发电折线图
    this.refreshMonitorData() // 概况模块数据
    this.getBankData() //农行定位
    this.getFourShopData() // 4s店定位
    this.getVehicleLocation() // 车辆定位信息
    this.getStationLocal() // 基站定位信息
    this.getRealTimeData() // 定时器,获取所有模块实时数据
  },
  methods: {
    // 点击工单概况跳转相应状态的工单
    goToOrder(data) {
      this.$router.push({
        name: "Dispatch",
        params: {
          id: data,
        },
      })
      this.$store.state.MenuStore.menu_path = "工单管理 > 派单管理"
    },
    // 点击车辆概况跳转相应状态的车辆
    goToVehicle(data) {
      this.$router.push({
        name: "Vehicle",
        params: {
          id: data,
        },
      })
      this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理"
    },
    // 实时获取监控的数据概况
    getRealTimeData() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.refreshMonitorData()
        this.getStationLocal()
        this.getVehicleLocation()
        this.getPowerCharts()
        if (this.carTimer) {
          this.getVehicleInfowindow(this.vin, this.deptId)
        }
        if (this.stationTimer) {
          this.getBaseStationInfowindow(this.stationId, this.lnglat)
        }
      }, 10 * 1000)
    },
    // 获取监控的四大模块概况数据
    async refreshMonitorData() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/general"
      )
      if (res.code == 1) {
        _this.monitorData = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //获取车辆定位信息
    async getVehicleLocation() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/vehicle"
      )
      if (res.code == 1) {
        _this.vehicleLocal = res.data
        _this.addVehicleMarker()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this
      let data = this.vehicleLocal
      if (this.vehicleMarker.length > 0) {
        this.map.remove(this.vehicleMarker)
        this.vehicleMarker = []
      }
      // if(this.oilStateMarkers.length>0){
      //   this.map.remove(this.oilStateMarkers)
      //   this.oilStateMarkers = []
      // }
      // if(this.powerStateMarkers.length>0){
      //   this.map.remove(this.powerStateMarkers)
      //   this.powerStateMarkers = []
      // }
      for (var i = 0; i < data.length; i++) {
        _this.varMarker = ""
        _this.oilStateMarker = ""
        _this.powerStateMarker = ""
        if (data[i].oilPumpingState == 1) {
          // _this.oilStateMarker.setMap(null)
          var oilContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-fueling.png") +
            "'/>"
          _this.oilStateMarker = new AMap.Marker({
            content: oilContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, 8),
            map: _this.map,
          })
        }
        if (data[i].powerState == 1) {
          // _this.powerStateMarker.setMap(null)
          var powerContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-powering.png") +
            "'/>"
          _this.powerStateMarker = new AMap.Marker({
            content: powerContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, -12),
            map: _this.map,
          })
        }
        if (data[i].vehicleState == 1) {
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: require("@/assets/images/monitor/car-offline.png"),
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 100,
            angel: -90,
          })
        } else {
          _this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: require("@/assets/images/monitor/car-online.png"),
            size: new AMap.Size(40, 24),
            map: _this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 200,
            angel: -90,
          })

          // 判断行驶方向
          _this.varMarker.moveAlong(data[i].directionLnglat, 50) //车辆行驶方向
        }
        _this.varMarker.content = data[i] // 车辆信息窗体内容
        _this.vehicleMarker.push(_this.varMarker)
        _this.vehicleMarker.push(_this.oilStateMarker)
        _this.vehicleMarker.push(_this.powerStateMarker)
        _this.varMarker.on("click", function(e) {
          _this.monitorLnglat = e.target.content.lnglat
          _this.stationTimer = false
          _this.carTimer = true
          if (_this.routeLine) {
            _this.driving.clear()
            _this.map.remove(_this.routeLine)
            _this.routeLine = null
          }
          _this.vin = e.target.content.vin
          _this.deptId = e.target.content.deptId
          _this.getVehicleInfowindow(_this.vin, _this.deptId)
          // 如果车辆有目的地，绘制车辆路径
          _this.drivingRoutel = ""
          _this.drivingTime = ""
          if (e.target.content.destLnglat.length > 0) {
            // 根据起终点经纬度规划驾车导航路线
            _this.driving.search(
              new AMap.LngLat(
                e.target.content.startLnglat[0],
                e.target.content.startLnglat[1]
              ),
              new AMap.LngLat(
                e.target.content.destLnglat[0],
                e.target.content.destLnglat[1]
              ),
              (status, result) => {
                var path = []
                for (var i = 0, l = result.routes[0].steps.length; i < l; i++) {
                  var step = result.routes[0].steps[i]
                  for (var j = 0, n = step.path.length; j < n; j++) {
                    path.push(step.path[j])
                  }
                }
                _this.drivingRoutel = result.routes[0].distance / 1000 + "公里"
                let hours = Math.floor(result.routes[0].time / 3600)
                let mintinus = Math.floor(
                  result.routes[0].time / 60 - hours * 60
                )
                _this.drivingTime = hours + "小时" + mintinus + "分钟"
                _this.routeLine = new AMap.Polyline({
                  map: _this.map,
                  path: path,
                  isOutline: false,
                  strokeWeight: 4,
                  strokeColor: "#00E46B",
                  lineJoin: "round",
                })
                _this.passedPolyline = new AMap.Polyline({
                  map: _this.map,
                  // path: lineArr,
                  strokeColor: "#CCC", //线颜色
                  // strokeOpacity: 1,     //线透明度
                  strokeWeight: 4, //线宽
                  // strokeStyle: "solid"  //线样式
                })

                if (_this.routeLine) {
                  _this.varMarker.on("moving", function(e) {
                    _this.passedPolyline.setPath(e.passedPath)
                  })
                }
                // _this.routeLine.setMap(_this.map)
              }
            )
          }
        })
      }
      _this.$nextTick(() => {
        _this.map.add(_this.vehicleMarker)
      })
    },
    // 点击查询车辆详情
    async getVehicleInfowindow(vin, deptId) {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/vehicle/details?deptId=" +
          deptId +
          "&vin=" +
          vin
      )
      if (res.code == 1) {
        let lnglat = sessionStorage.getItem("lnglat")
        _this.vehicleInfoWindowData = {}
        _this.vehicleInfoWindowData = res.data
        _this.vehicleId = true
        if (lnglat == res.data.lnglat) {
          if (_this.vehicleInfoSwitch) {
            _this.vehicleInfoWindow.open(_this.map, res.data.lnglat)
          } else {
            _this.vehicleInfoWindow.close()
          }
        } else {
          _this.vehicleInfoSwitch = true
          _this.vehicleInfoWindow.open(_this.map, res.data.lnglat)
        }
        sessionStorage.setItem("lnglat", res.data.lnglat)
        _this.vehicleInfoSwitch = !_this.vehicleInfoSwitch
      } else {
        _this.$message.warning(res.msg)
      }
    },

    //获取故障基站定位信息
    async getStationLocal() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/station"
      )
      if (res.code == 1) {
        _this.baseStationData = res.data
        _this.addStationMarks()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //添加基站标记
    addStationMarks() {
      let _this = this
      let data = this.baseStationData
      if (this.stationMarker.length > 0) {
        this.map.remove(this.stationMarker)
        this.stationMarker = []
      }
      if (_this.passedPolyline) {
        _this.driving.clear()
        _this.map.remove(_this.passedPolyline)
        _this.passedPolylinee = null
      }
      for (var i = 0; i < data.length; i++) {
        _this.varSMarker = ""
        _this.varSMarker = new AMap.Marker({
          position: data[i].lnglat,
          icon: require("@/assets/images/monitor/faultBaseStation.png"),
          size: new AMap.Size(20, 30),
          map: _this.map,
          offset: new AMap.Pixel(-10, -15),
        })
        _this.stationMarker.push(_this.varSMarker)
        _this.varSMarker.content = data[i]
        _this.varSMarker.on("click", function(e) {
          _this.carTimer = false
          _this.stationTimer = true
          if (_this.routeLine) {
            _this.driving.clear()
            _this.map.remove(_this.routeLine)
            _this.routeLine = null
          }
          _this.stationId = e.target.content.stationId
          _this.lnglat = e.target.content.lnglat
          _this.getBaseStationInfowindow(_this.stationId, _this.lnglat)
        })
      }
      _this.$nextTick(() => {
        _this.map.add(_this.stationMarker)
      })
    },
    // 点击查询基站详情
    async getBaseStationInfowindow(stationId, lnglat) {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/station/" + stationId
      )
      if (res.code == 1) {
        let BSlnglat = sessionStorage.getItem("BSlnglat")
        _this.baseStationInfoWindowData = {}
        _this.baseStationInfoWindowData = res.data
        _this.baseStationId = true
        if (BSlnglat == lnglat) {
          if (_this.baseStationSwitch) {
            _this.baseStationInfoWindow.open(_this.map, lnglat)
          } else {
            _this.baseStationInfoWindow.close()
          }
        } else {
          _this.baseStationSwitch = true
          _this.baseStationInfoWindow.open(_this.map, lnglat)
        }
        sessionStorage.setItem("BSlnglat", lnglat)
        _this.baseStationSwitch = !_this.baseStationSwitch
        // _this.baseStationInfoWindow.open(_this.map,lnglat);
      } else {
        _this.$message.warning(res.msg)
      }
    },

    // 获取农行数据
    async getBankData() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/bank"
      )
      if (res.code == 1) {
        _this.bankData = res.data
        _this.addBankMarks()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 添加农行图标
    addBankMarks() {
      let _this = this
      let data = this.bankData
      if (this.bankMarker.length > 0) {
        this.map.remove(this.bankMarker)
        this.bankMarker = []
      }
      for (var i = 0; i < data.length; i++) {
        _this.bkMarker = ""
        _this.bkMarker = new AMap.Marker({
          position: data[i].lnglat,
          icon: require("@/assets/images/monitor/bank.png"),
          size: new AMap.Size(20, 30),
          map: _this.map,
          offset: new AMap.Pixel(-10, -15),
        })
        _this.bankMarker.push(_this.bkMarker)
        _this.bkMarker.content = data[i]
        _this.bkMarker.on("click", function(e) {
          console.log(e)
          _this.bankInfoWindowData = {}
          _this.bankInfoWindowData = e.target.content
          console.log(_this.bankInfoWindowData)
          _this.bankId = true
          _this.bankInfoWindow.open(_this.map, e.target.content.lnglat)
        })
      }
      _this.$nextTick(() => {
        _this.map.add(_this.bankMarker)
      })
    },

    // 获取4S店数据
    async getFourShopData() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/statistics/data/repair/shop"
      )
      if (res.code == 1) {
        _this.fourShopData = res.data
        _this.fourShopData.filter((item) => {
          return item.style == 1
        })
        _this.addFourShopMarks()
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 添加4s店图标
    addFourShopMarks() {
      let _this = this
      let style = {
        url: require("@/assets/images/4S-shop.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(20, 30),
      }
      _this.fourShopMarks = new AMap.MassMarks(_this.fourShopData, {
        zIndex: 100, // 海量点图层叠加的顺序
        zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
        cursor: "pointer",
        style: style,
      })
      let fourShopMarker = new AMap.Marker({ content: " ", map: _this.map })
      AMap.event.addListener(_this.fourShopMarks, "mouseover", function(e) {
        fourShopMarker.setPosition(e.data.lnglat)
        fourShopMarker.setLabel({ content: e.data.name })
      })
      AMap.event.addListener(_this.fourShopMarks, "mouseout", function(e) {
        fourShopMarker.setPosition(e.data.lnglat)
        fourShopMarker.setLabel({ content: "" })
      })
      _this.fourShopMarks.setMap(_this.map)
    },
    // 点击跳转车辆详情
    getVehicleDetail(vin) {
      if (!vin) {
        this.$message.warning("车架号为空，无法查看车辆详情")
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: vin,
            active: "real",
          },
        })
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理"
      }
    },
    // 初始化地图及地图相关插件
    initMap() {
      let _this = this
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 12,
        mapStyle: "amap://styles/grey",
      })
      // 基站信息窗体
      this.baseStationInfoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.baseStationInfowindow.$el,
        offset: new AMap.Pixel(20, -40),
        anchor: "top-left",
        closeWhenClickMap: true,
        autoMove: true,
      })
      // 车辆信息窗体
      this.vehicleInfoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.vehicleInfowindow.$el,
        offset: new AMap.Pixel(27, -45),
        anchor: "top-left",
        closeWhenClickMap: true,
        autoMove: true,
      })
      // 农行信息窗体
      this.bankInfoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.bankInfowindow.$el,
        offset: new AMap.Pixel(20, -40),
        anchor: "top-left",
        closeWhenClickMap: true,
        autoMove: true,
      })
      // 初始化地图路线查询插件
      AMap.plugin("AMap.Driving", function() {
        _this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_FEE,
          hideMarkers: true,
          isOutline: false,
          autoFitView: true,
        })
      })

      // 点击地图，清除路线规划
      AMap.event.addListener(this.map, "click", function() {
        if (_this.routeLine) {
          _this.driving.clear()
          _this.map.remove(_this.routeLine)
          _this.routeLine = null
        }
      })
      this.vehicleInfoWindow.on("close", () => {
        _this.carTimer = false
      })
      this.baseStationInfoWindow.on("close", () => {
        _this.stationTimer = false
      })
      // 判断地图中心点
      let monitorLnglat = sessionStorage.getItem("monitorLnglat")
      if (monitorLnglat) {
        monitorLnglat = monitorLnglat.split(",")
        this.map.setCenter(monitorLnglat)
      }
    },
    // 发电量折线图初始化相关配置
    initCharts() {
      let _this = this
      let showed = this.datay.length ? false : true
      this.myChart = this.$echarts.init(document.getElementById("chart"))
      this.myChart.setOption({
        title: {
          show: showed,
          text: "暂无发电数据...",
          left: "center",
          top: "center",
          textStyle: {
            fontWeight: "normal",
            color: "#999999",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              backgroundColor: "#00FAC0",
            },
          },
        },
        grid: {
          left: "10%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: { color: "#97ABEA" },
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          data: _this.datax,
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "单位：KW·H",
          nameTextStyle: {
            color: "#97ABEA",
            fontSize: 12,
          },
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: { color: "#97ABEA" },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "发电量",
            data: _this.datay,
            // data: [22, 32, 10,33, 40, 44, 46],
            type: "line",
            itemStyle: {
              color: "#00FAC0",
            },
            showSymbol: false,
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(0,250,192,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(0,250,192,0)",
                },
              ]),
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
          },
        ],
      })
      window.addEventListener("resize", () => {
        _this.myChart.resize()
      })
    },
    // 获取发电量折线图数据
    async getPowerCharts() {
      let _this = this
      _this.datax = []
      _this.datay = []
      let { data: res } = await _this.$axios.get(
        "/api/v2/maintain/monitor/dynamo/kChart"
      )
      if (res.code == 1) {
        for (let i = 0; i < res.data.length; i++) {
          _this.datax.push(res.data[i].date)
          _this.datay.push(res.data[i].value)
        }
        _this.initCharts()
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
  // 消除定时器
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
$font-name: "Arial Negreta", "Arial";
.box-border {
  box-sizing: border-box;
}
.con-wrap {
  position: relative;
  background-color: #fff;
  .watch-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    max-width: 1660px;
    height: 75px;
    background: url("../../../assets/images/monitor/watch-header.png") no-repeat;
    background-size: 100% auto;
    .header-title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      font-family: $font-name;
      font-weight: bold;
      color: #00c9f0;
      letter-spacing: 4px;
    }
  }
  .openMap {
    position: absolute;
    left: 10px;
    top: 20px;
    color: #fff;
    cursor: pointer;
  }
  .reload-time {
    position: absolute;
    top: 90px;
    left: 30px;
    font-size: 16px;
    font-family: $font-name;
    font-weight: 500;
    color: #fff;
  }
  .survey-wrapper {
    position: absolute;
    top: 120px;
    .survey-box {
      width: 412px;
      height: 226px;
      background: url("../../../assets/images/monitor/watch-box.png");
      margin-bottom: 10px !important;
      z-index: 100000000;
      .survey-header {
        padding-top: 10px;
        font-size: 18px;
        font-family: $font-name;
        font-weight: 500;
        color: #00caf0;
      }
      .survey-vehicle {
        padding-left: 20px;
        .vehicle-num {
          width: 120px;
          height: 120px;
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          text-align: center;
          padding-top: 32px !important;
          .nums {
            font-size: 28px;
            font-weight: 500;
          }
          .online-num {
            color: #0eec71;
          }
          .offline-num {
            color: #ec0e67;
          }
          .powering-num {
            color: #00fdf6;
          }
        }
        .online {
          background: url("../../../assets/images/monitor/online.png");
        }
        .offline {
          background: url("../../../assets/images/monitor/offline.png");
        }
        .powering {
          background: url("../../../assets/images/monitor/powering.png");
        }
        .baseStation-num {
          background: url("../../../assets/images/monitor/base-station-num.png");
        }
        .powerCut-num {
          background: url("../../../assets/images/monitor/power-cut-num.png");
        }
        .ordering {
          background: url("../../../assets/images/monitor/ordering.png");
        }
        .no-order {
          background: url("../../../assets/images/monitor/no-order.png");
        }
      }
      .survey-baseStation {
        .vehicle-num {
          width: 172px;
          height: 130px;
        }
      }
      .survey-order {
        .vehicle-num {
          width: 120px;
          height: 150px;
        }
      }
    }
  }
  .left-wrapper {
    left: 10px;
  }
  .right-wrapper {
    right: 10px;
  }
  // 高德地图窗体
  .infoWindow {
    position: relative;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    width: 185px;
    border-radius: 4px;
    .orderTime {
      position: absolute;
      width: 185px;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.8);
      top: -22px;
      left: 0;
      border-radius: 3px;
      padding-left: 10px;
    }
    .infoWindow-detail {
      .carNumber {
        color: #0060ff;
      }
      .vehicleStatus {
        span {
          display: inline-block;
          text-align: center;
          width: 54px;
          height: 20px;
          border-radius: 10px;
          margin-right: 5px;
          color: rgba(255, 255, 255, 0.8);
        }
        .powering {
          background: #00beda;
        }
        .fueling {
          background: #ffa200;
        }
        .routing {
          background: #00cb4c;
        }
        .no-receive {
          background: #888888;
        }
        .no-order {
          background: #0078ff;
        }
      }
    }
    // 三角形
    .delta {
      position: absolute;
      left: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }
    // 查看详情
    .checkDetail {
      position: absolute;
      right: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }
  }
}
#map-box {
  width: 100%;
  height: 100%;
  min-height: 720px;
}
</style>
